import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from ".././axios-interceptor";
import moment from "moment";
import SideNavBar from "./SideNavBar";
import NavBarMain from "./NavBarMain";
import { base_url, NOTIFICATION_TYPE_PAYMENT_PROCESSED, NOTIFICATION_TYPE_LOAN_CLOSED, NOTIFICATION_TYPE_EXTEND_TENURE_APPROVED, NOTIFICATION_TYPE_EXTEND_TENURE_REJECTED, NOTIFICATION_TYPE_PRE_CLOSURE_REJECTED, NOTIFICATION_TYPE_PRE_CLOSURE_APPROVED, NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_APPROVED, NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_REJECTED, NOTIFICATION_TYPE_AWAITING_FOR_YOUR_RESPONSE, LOAN_CURRENCY_TYPE_USD, NOTIFICATION_ENTITY_BUSINESS, NOTIFICATION_TYPE_BUSINESS_AGREED_TERMS, NOTIFICATION_TYPE_LOAN_REQUEST_NOTIFICATION, NOTIFICATION_TYPE_NEW_LOAN_REJECTED, NOTIFICATION_TYPE_RENEW_DOCUMENT, NOTIFICATION_TYPE_KYC_APPROVED, NOTIFICATION_TYPE_KYC_REJECTED, NOTIFICATION_TYPE_LOAN_TECHNICAL_CLOSURE, NOTIFICATION_TYPE_LOAN_DELISTED } from "../utilities";
import { toast } from "react-toastify";
import Skeleton from "react-loading-skeleton";
import Cookies from 'js-cookie';

const Notifications = () => {
  const [activeTab, setActiveTab] = useState('home');
  function handleTabClick(tab) {
    setActiveTab(tab);
  }
  const navigate = useNavigate();
  useEffect(() => {
    if (!Cookies.get("User_Accesstoken_Business")) {
      navigate('/');
    }
  }, []);

  const [loading, setLoading] = useState(false)
  const [notificationData, setNotificationData] = useState([])
  useEffect(() => {
    setLoading(true)
    axios
      .post(base_url + 'notifications/get_business_notifications', {
        user_id: Cookies.get("business_id"),
        notify_to: NOTIFICATION_ENTITY_BUSINESS
      })
      .then((res) => {

        setNotificationData(res.data.data)
        setLoading(false)

      })

  }, [])

  let Count = [];

  let notificationList = []


  notificationData?.forEach(notifi => {
    if (notifi.is_read !== 1) {
      Count.push(notifi)
    }


    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_AWAITING_FOR_YOUR_RESPONSE) {
      notificationList.push(
        {
          heading: 'Congratulations! your loan has been sanctioned',
          msgBody: `Please refer to the details and accept the loan terms for your money to be received to this ${notifi.reference_number}`,
          notifType: notifi.notification_type,
          date: notifi.created_date_time,
          is_read: notifi.is_read,
          notification_id: notifi.notification_id
        }
      )
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_PAYMENT_PROCESSED) {
      notificationList.push(
        {
          heading: 'Congratulations! your payment has been processed',
          msgBody: `Your payment has been processed successfully for loan ref no.${notifi.reference_number}`,
          notifType: notifi.notification_type,
          date: notifi.created_date_time,
          is_read: notifi.is_read,
          notification_id: notifi.notification_id

        })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_KYC_APPROVED) {
      notificationList.push(
        {
          heading: 'Business KYC form has been approved',
          msgBody: `KYC has been approved by the admin ref no.${notifi.reference_number}`,
          notifType: notifi.notification_type,
          date: notifi.created_date_time,
          is_read: notifi.is_read,
          notification_id: notifi.notification_id

        })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_KYC_REJECTED) {
      notificationList.push(
        {
          heading: 'Business KYC form has been rejected',
          msgBody: `KYC has been rejected by the admin ref no.${notifi.reference_number}`,
          notifType: notifi.notification_type,
          date: notifi.created_date_time,
          is_read: notifi.is_read,
          notification_id: notifi.notification_id

        })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_LOAN_CLOSED) {
      notificationList.push(
        {
          heading: 'Loan closed',
          msgBody: `Your loan ${notifi.reference_number} has been successfully closed`,
          notifType: notifi.notification_type,
          date: notifi.created_date_time,
          is_read: notifi.is_read,
          notification_id: notifi.notification_id
        }
      )
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_EXTEND_TENURE_APPROVED) {
      notificationList.push({
        heading: 'Tenure extension request has been approved',
        msgBody: `Request for extend tenure has been approved for loan ${notifi.reference_number} `,
        notifType: notifi.notification_type,
        date: notifi.created_date_time,
        is_read: notifi.is_read,
        notification_id: notifi.notification_id
      })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_EXTEND_TENURE_REJECTED) {
      notificationList.push({
        heading: 'Tenure extension request has been rejected',
        msgBody: `Request for extend tenure has been rejected for loan ${notifi.reference_number} `,
        notifType: notifi.notification_type,
        date: notifi.created_date_time,
        is_read: notifi.is_read,
        notification_id: notifi.notification_id
      })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_PRE_CLOSURE_APPROVED) {
      notificationList.push({
        heading: 'Pre-closure request has been approved',
        msgBody: `Request for pre-closure has been approved for loan ${notifi.reference_number} `,
        notifType: notifi.notification_type,
        date: notifi.created_date_time,
        is_read: notifi.is_read,
        notification_id: notifi.notification_id
      })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_PRE_CLOSURE_REJECTED) {
      notificationList.push({
        heading: 'Pre-closure request has been rejected',
        msgBody: `Request for pre-closure has been rejected for loan ${notifi.reference_number} `,
        notifType: notifi.notification_type,
        date: notifi.created_date_time,
        is_read: notifi.is_read,
        notification_id: notifi.notification_id
      })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_APPROVED) {
      notificationList.push({
        heading: 'Partial pre-payment request has been approved',
        msgBody: `Request for partial pre-payment has been approved for loan ${notifi.reference_number} `,
        notifType: notifi.notification_type,
        date: notifi.created_date_time,
        is_read: notifi.is_read,
        notification_id: notifi.notification_id
      })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_REJECTED) {
      notificationList.push({
        heading: 'Partial pre-payment request has been rejected',
        msgBody: `Request for partial pre-payment has been rejected for loan ${notifi.reference_number} `,
        notifType: notifi.notification_type,
        date: notifi.created_date_time,
        is_read: notifi.is_read,
        notification_id: notifi.notification_id
      })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_LOAN_REQUEST_NOTIFICATION) {
      notificationList.push({
        heading: 'New loan request raised',
        msgBody: `New loan request has been raised ${notifi.reference_number} `,
        notifType: notifi.notification_type,
        date: notifi.created_date_time,
        is_read: notifi.is_read,
        notification_id: notifi.notification_id
      })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_NEW_LOAN_REJECTED) {
      notificationList.push({
        heading: 'New loan request has been rejected',
        msgBody: `New loan request has been rejected ${notifi.reference_number} `,
        notifType: notifi.notification_type,
        date: notifi.created_date_time,
        is_read: notifi.is_read,
        notification_id: notifi.notification_id
      })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_LOAN_TECHNICAL_CLOSURE) {
      notificationList.push({
        heading: 'Loan technical closure',
        msgBody: `Loan ${notifi.reference_number} has been technical closed `,
        notifType: notifi.notification_type,
        date: notifi.created_date_time,
        is_read: notifi.is_read,
        notification_id: notifi.notification_id
      })
    }
    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_LOAN_DELISTED) {
      notificationList.push({
        heading: 'Loan delisted',
        msgBody: `Loan ${notifi.reference_number} has been delisted `,
        notifType: notifi.notification_type,
        date: notifi.created_date_time,
        is_read: notifi.is_read,
        notification_id: notifi.notification_id
      })
    }


    if (parseInt(notifi.notification_type) === NOTIFICATION_TYPE_RENEW_DOCUMENT) {
      if (notifi.status < new Date()) {
        notificationList.push({
          heading: 'KYC document expiry',
          msgBody: `Renew your ${notifi.reference_number} document which is expired on ${moment(notifi.status).format("DD MMM YYYY")}`,
          notifType: notifi.notification_type,
          date: notifi.created_date_time,
          is_read: notifi.is_read,
          notification_id: notifi.notification_id
        })
      }
      else {
        notificationList.push({
          heading: 'KYC document expiry',
          msgBody: `Renew your ${notifi.reference_number} document which will expire on ${moment(notifi.status).format("DD MMM YYYY")}`,
          notifType: notifi.notification_type,
          date: notifi.created_date_time,
          is_read: notifi.is_read,
          notification_id: notifi.notification_id
        })
      }
    }


  })

  let notifLength = Count.length

  const handleViewDetails = (data) => {

    axios
      .post(base_url + 'notifications/update_is_read_notification', {

        "notification_id": data.notification_id
      })
      .then((res) => {
        switch (parseInt(data.notifType)) {
          case NOTIFICATION_TYPE_AWAITING_FOR_YOUR_RESPONSE:
          case NOTIFICATION_TYPE_EXTEND_TENURE_APPROVED:
          case NOTIFICATION_TYPE_PRE_CLOSURE_APPROVED:
          case NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_APPROVED:
          case NOTIFICATION_TYPE_EXTEND_TENURE_REJECTED:
          case NOTIFICATION_TYPE_PRE_CLOSURE_REJECTED:
          case NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_REJECTED:
            if (window.location.pathname === '/myservicerequests') {
              setTimeout(() => {
                window.location.reload()
              }, 800);
            } else {
              navigate("/myservicerequests")
            }
            break;
          case NOTIFICATION_TYPE_PAYMENT_PROCESSED:
          case NOTIFICATION_TYPE_LOAN_CLOSED:
          case NOTIFICATION_TYPE_NEW_LOAN_REJECTED:
            if (window.location.pathname === '/myloans') {
              setTimeout(() => {
                window.location.reload()
              }, 800);
            } else {
              navigate("/myloans")
            }
            break;
          case NOTIFICATION_TYPE_RENEW_DOCUMENT:
            if (window.location.pathname === '/kycdocuments') {
              setTimeout(() => {
                window.location.reload()
              }, 800);
            } else {
              navigate("/kycdocuments")
            }
            break;
          case NOTIFICATION_TYPE_KYC_APPROVED:
          case NOTIFICATION_TYPE_KYC_REJECTED:
            if (window.location.pathname === "/kycform") {

              setTimeout(() => {
                window.location.reload();
              }, 800);
            } else {

              navigate("/kycform");
            }
            break;

          default:
            navigate("/notifications");
            break;
        }
      }).catch((e) => {
      })
  }

  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <SideNavBar />
      <main style={{ width: "100%" }}>
        <NavBarMain count={notifLength} />

        <div className="col-lg-9 m-auto mt-4">
          <h1 className="bus_notific_main">Notifications</h1>



          <div className="">
            <ul className="nav nav-tabs notif_main" id="myTab" role="tablist">
              <li className="nav-item">
                <a className={`nav-link ${activeTab === 'home' ? 'notif_main_active_home' : 'notifinactivestyle_home'}`} onClick={() => handleTabClick('home')} role="tab" aria-selected={activeTab === 'home'}>Read</a>
              </li>
              <li className="nav-item position-relative">
                {Count.length === 0 ? '' : <span className="notifCount">{Count.length}</span>}
                <a className={`nav-link ${activeTab === 'profile' ? 'notif_main_active_profile' : 'notifinactivestyle_profile'}`} onClick={() => handleTabClick('profile')} role="tab" aria-selected={activeTab === 'profile'}>
                  Unread</a>
              </li>

            </ul>
            <div className="tab-content">
              <div className={`tab-pane ${activeTab === 'home' ? 'active' : ''}`} id="home" role="tabpanel">


                <div className="notif_main_div">
                  {loading ? <div>
                    <Skeleton height={50} />
                    <Skeleton height={50} />
                  </div> : notificationList.length === 0 ? <div className="text-center text-secondary fs-5 fw-bold mt-5">No notifications to display</div> : notificationList.map(notif => {
                    if (notif.is_read === 1)
                      return (
                        <div key={notif.ref_no} className="notifpanestyl row me-3">

                          <div className="col-lg-2 notif_time">
                            <b className="notif_date">{moment(notif.date).format("DD MMM YYYY")}</b>
                            <p >{moment(notif.date).format("HH:mm")}</p>
                          </div>
                          <div className="col notif_txt">
                            <h3 className="mb-1">{
                              notif.heading
                            }</h3>
                            <p>{notif.msgBody}.</p>
                          </div>

                        </div>
                      )


                  })}
                </div>


              </div>
              <div className={`tab-pane ${activeTab === 'profile' ? 'active' : ''}`} id="profile" role="tabpanel">

                <div className="notif_main_div">
                  {loading ? <div>
                    <Skeleton height={50} />
                    <Skeleton height={50} />
                  </div> : Count.length === 0 ? <div className="text-center  fw-bold text-secondary mt-5 fs-5">No new notifications</div> :
                    notificationList.map(notif => {
                      if (notif.is_read === 0)
                        return (
                          <div key={notif.ref_no} className="notifpanestyl row me-3">
                            <div className="col-lg-2 notif_time">
                              <b className="notif_date">{moment(notif.date).format("DD MMM YYYY")}</b>
                              <p >{moment(notif.date).format("HH:mm")}</p>
                            </div>

                            <div className="col notif_txt">
                              <h3 className="mb-0">{notif.heading}</h3>
                              <p>{notif.msgBody}.</p>
                              <div className="d-flex gap-3 mt-2">
                                <span className="toast_viewdetails" onClick={() => handleViewDetails(notif)}>View Details</span>
                              </div>
                            </div>

                          </div>
                        )


                    })}
                </div>

              </div>
            </div>
          </div>







        </div>
      </main>
    </div>
  )
}

export default Notifications;
